import { render } from "./HomeCasos.vue?vue&type=template&id=aae627ca"
import script from "./HomeCasos.vue?vue&type=script&lang=js"
export * from "./HomeCasos.vue?vue&type=script&lang=js"

import "./HomeCasos.vue?vue&type=style&index=0&id=aae627ca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__